// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import POrderedListOutlinedSvg from "@fishx/icons-svg/es/asn/POrderedListOutlined";
import FishxIcon from '../components/FishxIcon';

var POrderedListOutlined = function POrderedListOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: POrderedListOutlinedSvg
  }));
};

POrderedListOutlined.displayName = 'POrderedListOutlined';
export default React.forwardRef(POrderedListOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/POrderedListOutlined.js
// module id = 3526
// module chunks = 0